import { Action } from '@ngrx/store';
import { IWizardSpecification } from '../../../../shared/modules/configurable-form/models/i-wizard-specification';
import { SummaryConfig } from '../models/summary-element-config';

export enum SummaryActionTypes {
  LOAD_CONFIG = '[Summary] Load Config',
  LOAD_CONFIG_COMPLETE = '[Summary] Load Config Complete',
  SET_TERMS = '[Summary] Terms set',
  SET_SPECIAL_INVOICE = '[Summary] Special invoice set',
  RESET_SUMMARY = '[Summary] Reset summary',
}

export class SummaryLoadConfigAction implements Action {
  readonly type = SummaryActionTypes.LOAD_CONFIG;

  constructor(public payload: IWizardSpecification) {}
}

export class SummaryLoadConfigCompleteAction implements Action {
  readonly type = SummaryActionTypes.LOAD_CONFIG_COMPLETE;

  constructor(public payload: SummaryConfig) {}
}

export class SetTermsAction implements Action {
  readonly type = SummaryActionTypes.SET_TERMS;

  constructor(public payload: boolean) {}
}

export class SetSpecialInvoiceAction implements Action {
  readonly type = SummaryActionTypes.SET_SPECIAL_INVOICE;

  constructor(public payload: boolean) {}
}

export class ResetSummaryAction implements Action {
  readonly type = SummaryActionTypes.RESET_SUMMARY;

  constructor() {}
}

export type SummaryActions =
  | SummaryLoadConfigAction
  | SummaryLoadConfigCompleteAction
  | SetTermsAction
  | SetSpecialInvoiceAction
  | ResetSummaryAction;
